"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const uploadDocument_web_1 = __importDefault(require("../../../components/documentUpload/uploadDocument.web"));
const store_1 = require("../../../store");
const surveySlice_1 = require("../surveySlice");
const styles_1 = __importDefault(require("../../../styles/styles"));
const text_1 = __importStar(require("../../../components/text/text"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const utils_1 = require("../../../utils/utils");
const constants_1 = require("../../../constants/constants");
const analytics_1 = require("../../../utils/analytics/analytics");
const UploadFile = ({ documentType, loanApplicationId, setShowUpload, errors }) => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const [file, setFile] = (0, react_1.useState)('');
    const [name, setName] = (0, react_1.useState)('');
    const uploadDocument = async () => {
        const formData = new FormData();
        if (typeof file === 'string') {
            const fileBlob = await fetch(file).then((r) => r.blob());
            // @ts-ignore
            formData.append('document', fileBlob, name);
        }
        formData.append('loan_application_id', loanApplicationId);
        const result = await dispatch((0, surveySlice_1.submitDocument)({ body: formData, document_type: documentType }));
        logEventWithExtraProperties('api_call', {
            name: 'submit_document',
            status: 'submitted',
            location: 'screen_UploadFile',
            type: documentType,
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_document',
                status: 'success',
                location: 'screen_UploadFile',
                type: documentType,
            });
            setShowUpload(false);
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_document',
                status: 'fail',
                location: 'screen_UploadFile',
                type: documentType,
            });
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        !!errors && (react_1.default.createElement(react_native_1.View, { style: [
                styles_1.default.mainContainerPadding,
                styles_1.default.minimumMarginBetweenElementsVertically,
                styles_1.default.flexDirectionColumn,
                styles_1.default.centerChildHorizontalVertical,
                { marginTop: 20 },
            ] },
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: colors_1.default.COLOR_CRITICAL }, `${(0, utils_1.getError)('non_field_errors', errors)
                ? (0, utils_1.getError)('non_field_errors', errors)
                : constants_1.DEFAULT_ERROR_MESSAGE}`))),
        react_1.default.createElement(uploadDocument_web_1.default, { setDocument: setFile, document: file, setName: setName }),
        react_1.default.createElement(primaryButton_1.default, { disabled: !!file, title: "Submit", onPress: uploadDocument, eventName: "upload_document" })));
};
exports.default = UploadFile;
